import { render, staticRenderFns } from "./img-detail.vue?vue&type=template&id=051cd106&scoped=true&"
import script from "./img-detail.vue?vue&type=script&lang=js&"
export * from "./img-detail.vue?vue&type=script&lang=js&"
import style0 from "./img-detail.vue?vue&type=style&index=0&id=051cd106&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051cd106",
  null
  
)

export default component.exports